/* TailorTail Co — Pet Photo Upload (Cloudinary) */

(function() {
  'use strict';

  var containers = document.querySelectorAll('[data-photo-upload]');
  if (!containers.length) return;

  var config = window.TailorTail && window.TailorTail.cloudinary || {};
  var maxSize = 20 * 1024 * 1024; // 20MB
  var allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];

  function resizeImageForCart(file, callback) {
    var img = new Image();
    img.onload = function() {
      var maxDim = 200;
      var w = img.width;
      var h = img.height;
      if (w > maxDim || h > maxDim) {
        if (w > h) { h = Math.round(h * maxDim / w); w = maxDim; }
        else { w = Math.round(w * maxDim / h); h = maxDim; }
      }
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      callback(canvas.toDataURL('image/jpeg', 0.7));
    };
    img.src = URL.createObjectURL(file);
  }

  containers.forEach(function(container) {
    initUploadWidget(container);
  });

  function initUploadWidget(container) {
    var dropzone = container.querySelector('[data-upload-dropzone]');
    var fileInput = container.querySelector('[data-upload-input]');
    var progressEl = container.querySelector('[data-upload-progress]');
    var progressFill = container.querySelector('[data-progress-fill]');
    var previewEl = container.querySelector('[data-upload-preview]');
    var previewImage = container.querySelector('[data-preview-image]');
    var previewName = container.querySelector('[data-preview-name]');
    var removeBtn = container.querySelector('[data-upload-remove]');
    var hiddenInput = container.querySelector('[data-photo-url]');

    if (!dropzone || !fileInput || !hiddenInput) return;

    // Drag and drop events
    ['dragenter', 'dragover'].forEach(function(event) {
      dropzone.addEventListener(event, function(e) {
        e.preventDefault();
        dropzone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach(function(event) {
      dropzone.addEventListener(event, function(e) {
        e.preventDefault();
        dropzone.classList.remove('is-dragover');
      });
    });

    dropzone.addEventListener('drop', function(e) {
      var files = e.dataTransfer.files;
      if (files.length > 0) handleFile(files[0]);
    });

    // File input change
    fileInput.addEventListener('change', function() {
      if (this.files.length > 0) handleFile(this.files[0]);
    });

    // Remove photo
    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        resetUpload();
      });
    }

    function handleFile(file) {
      if (!validateFile(file)) return;

      showPreviewLocal(file);
      uploadToCloudinary(file);
    }

    function validateFile(file) {
      if (!allowedTypes.includes(file.type)) {
        alert('Please upload a PNG, JPG, or WebP image.');
        return false;
      }
      if (file.size > maxSize) {
        alert('File is too large. Maximum size is 20MB.');
        return false;
      }
      return true;
    }

    function showPreviewLocal(file) {
      var reader = new FileReader();
      reader.onload = function(e) {
        if (previewImage) previewImage.src = e.target.result;
        if (previewName) previewName.textContent = file.name;
      };
      reader.readAsDataURL(file);
    }

    function uploadToCloudinary(file) {
      if (!config.cloudName || !config.uploadPreset) {
        resizeImageForCart(file, function(dataUrl) {
          hiddenInput.value = dataUrl;
          hiddenInput.setAttribute('value', dataUrl);
          showSuccess();
        });
        return;
      }

      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', config.uploadPreset);
      formData.append('folder', 'tailortail-pets');

      var url = 'https://api.cloudinary.com/v1_1/' + config.cloudName + '/image/upload';

      dropzone.hidden = true;
      if (progressEl) progressEl.hidden = false;
      if (previewEl) previewEl.hidden = true;

      var xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('progress', function(e) {
        if (e.lengthComputable && progressFill) {
          var percent = Math.round((e.loaded / e.total) * 100);
          progressFill.style.width = percent + '%';
        }
      });

      xhr.addEventListener('load', function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          var response = JSON.parse(xhr.responseText);
          hiddenInput.value = response.secure_url;
          hiddenInput.setAttribute('value', response.secure_url);
          showSuccess();
        } else {
          alert('Upload failed. Please try again.');
          resetUpload();
        }
      });

      xhr.addEventListener('error', function() {
        alert('Upload failed. Please check your connection and try again.');
        resetUpload();
      });

      xhr.open('POST', url);
      xhr.send(formData);
    }

    function showSuccess() {
      dropzone.hidden = true;
      dropzone.classList.remove('photo-upload__dropzone--error');
      if (progressEl) progressEl.hidden = true;
      if (previewEl) previewEl.hidden = false;
      var uploadGroup = container.closest('[data-photo-upload-group]');
      if (uploadGroup) {
        var errEl = uploadGroup.querySelector('.form-error');
        if (errEl) errEl.hidden = true;
      }
    }

    function resetUpload() {
      fileInput.value = '';
      hiddenInput.value = '';
      hiddenInput.setAttribute('value', '');
      if (previewImage) previewImage.src = '';
      if (previewName) previewName.textContent = '';
      if (progressFill) progressFill.style.width = '0%';

      dropzone.hidden = false;
      if (progressEl) progressEl.hidden = true;
      if (previewEl) previewEl.hidden = true;
    }
  }
})();
